  <span class="title">Confirmation from driver pending</span>
  <div class="padding-top-md padding-left-md padding-bottom-sm">
    Driver:
    <span class="quote-title padding-left-sm">{{actorName}}</span>
  </div>
  <div class="padding-left-lg margin-botton-lg">
    Price:
    <span class="padding-left-sm" *ngIf="primaryOfferRate != undefined">${{primaryOfferRate}}</span>
  </div>
